import Editor from './components/Editor.vue';
import EditorItem from './components/EditorItem.vue';
import EditorItemDesign from './components/elements/EditorItemDesign.vue';
import EditorItemExternal from './components/elements/EditorItemExternal.vue';
import EditorItemGroup from './components/elements/EditorItemGroup.vue';
import EditorItemText from './components/elements/EditorItemText.vue';
import EditorItemUpload from './components/elements/EditorItemUpload.vue';

export let BASE_LAYER_ZINDEX = 50;

let compostionRenderer = {
  config: {
    creatorBaseUrl: '',
    creatorApiUrl: '',
    baseLayerZIndex: BASE_LAYER_ZINDEX
  },
  uploadResolver(element) {
    return this.customUploadResolver(
      element,
      this.config,
      this.defaultUploadResolver
    );
  },
  defaultUploadResolver(element, config) {
    let effectConfig = '';
    for (const elementConfig in element.config) {
      effectConfig += `&${elementConfig}=${element.config[elementConfig]}`;
    }

    return `${config.creatorApiUrl}customer_image/effect?srcFile=${element.srcFile}&effect=${element.effect}${effectConfig}&bgRemoval=${element.bgRemoval}`;
  },
  customUploadResolver(element, config, defaultResolver) {
    return defaultResolver(element, config);
  },
  textResolver(element) {
    return this.customTextResolver(
      element,
      this.config,
      this.defaultTextResolver
    );
  },
  defaultTextResolver(element, config) {
    const encodedText = encodeURIComponent(element.text);

    let effectConfig = '';
    for (const elementConfig in element.effectConfig) {
      effectConfig += `&${elementConfig}=${element.effectConfig[elementConfig]}`;
    }

    return `${config.creatorApiUrl}text?text=${encodedText}&font=${element.font}&color=${element.color}&align=${element.align}&effect=${element.effect}&effectColor=${element.effectColor}${effectConfig}`;
  },
  customTextResolver(element, config, defaultResolver) {
    return defaultResolver(element, config);
  },
  designResolver(element) {
    return this.customDesignResolver(
      element,
      this.config,
      this.defaultDesignResolver
    );
  },
  defaultDesignResolver(element, config) {
    const directory = 250 + Math.floor(element.id / 250) * 250;

    return `${config.creatorBaseUrl}/media/designs/${directory}/${element.id}_300x300.png`;
  },
  customDesignResolver(element, config, defaultResolver) {
    return defaultResolver(element, config);
  }
};

export default {
  install: (app, options = {}) => {
    registerComponents(app);

    if (!options.creatorBaseUrl) {
      throw "'creatorBaseUrl' needs to be set in the composition-renderer plugin options";
    }

    compostionRenderer.config.creatorApiUrl = `${options.creatorBaseUrl}/api/v0/`;
    compostionRenderer.config.creatorBaseUrl = options.creatorBaseUrl;

    if (options.customResolver) {
      if (options.customResolver.upload) {
        compostionRenderer.customUploadResolver = options.customResolver.upload;
      }
      if (options.customResolver.design) {
        compostionRenderer.customDesignResolver = options.customResolver.design;
      }
      if (options.customResolver.text) {
        compostionRenderer.customTextResolver = options.customResolver.text;
      }
    }

    app.prototype.$compositionRenderer = compostionRenderer;
  }
};

function registerComponents(app) {
  app.component(Editor.name, Editor);
  app.component(EditorItem.name, EditorItem);
  app.component(EditorItemDesign.name, EditorItemDesign);
  app.component(EditorItemExternal.name, EditorItemExternal);
  app.component(EditorItemGroup.name, EditorItemGroup);
  app.component(EditorItemText.name, EditorItemText);
  app.component(EditorItemUpload.name, EditorItemUpload);
}
